const DueDiligenceProcedures = {
  NotReported: 0,
  NewAccount: 1,
  PreexistingAccount: 2,

  getDescription(type) {
    switch (type) {
      case DueDiligenceProcedures.NotReported:
        return 'Not Reported';
      case DueDiligenceProcedures.NewAccount:
        return 'New Account';
      case DueDiligenceProcedures.PreexistingAccount:
        return 'Preexisting Account';
      default:
        return 'Not Reported';
    }
  }
};

export default DueDiligenceProcedures;
